/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidformaterror2Inputs */

const en_invalidformaterror2 = /** @type {(inputs: Invalidformaterror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The format of the entered data is invalid.`)
};

const de_invalidformaterror2 = /** @type {(inputs: Invalidformaterror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Format der eingegebenen Daten ist ungültig.`)
};

/**
* | output |
* | --- |
* | "The format of the entered data is invalid." |
*
* @param {Invalidformaterror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidformaterror2 = /** @type {((inputs?: Invalidformaterror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidformaterror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidformaterror2(inputs)
	return de_invalidformaterror2(inputs)
});
export { invalidformaterror2 as "invalidFormatError" }